import router from "@/router";
import store from "@/store";
export default class ViewAppointmentAction {
    type;
    id;
    educationClass;
    constructor(type, id, educationClass) {
        this.type = type;
        this.id = id;
        this.educationClass = educationClass;
    }
    async run() {
        const data = {
            action: 'ViewAppointment',
            type: this.type,
            educationClass: this.educationClass,
            id: this.id
        };
        store.commit('setPushNotificationAction', data);
        if (router.currentRoute.value.name !== 'CampusApp') {
            await router.push({ name: 'CampusApp', query: data });
        }
        const webviewIframeEl = document.getElementById('webviewIframe');
        const contentWindow = webviewIframeEl.contentWindow;
        if (contentWindow !== null) {
            contentWindow.postMessage(data, '*');
        }
    }
}
